<template>
    <div>
        <el-container class="mainInfo" v-loading="loading">
            <el-main>
                <div class="dialog_body">
                    <el-tabs style="padding: 0 20px" v-model="activeName">
                        <el-tab-pane name="first">
                            <span slot="label"><i class="el-icon-setting"></i> 基本设置 </span>
                            <div style="text-align: left">
                                <div style="padding-left: 20px;padding-bottom: 20px;margin-top:20px;display: none">
                                    <el-checkbox v-model="formData.zeroPrice"
                                                 :checked="formData.zeroPrice==1?true:false" :true-label="1"
                                                 :false-label="0" border> 记账: 允许记账时单价等于0(记数量账)
                                    </el-checkbox>
                                </div>
                                <div style="padding-left: 20px;padding-bottom: 20px">
                                    <el-checkbox v-model="formData.negativeInventory"
                                                 :checked="formData.negativeInventory==1?true:false" :true-label="1"
                                                 :false-label="0" border>记账: 当前库存出现负库存时不允许存盘
                                    </el-checkbox>
                                </div>
                                <div style="padding-left: 20px;padding-bottom: 20px">
                                    <el-checkbox v-model="formData.modifyBill"
                                                 :checked="formData.modifyBill==1?true:false"
                                                 :true-label="1" :false-label="0" border>设置: 允许进行(单据修改)
                                    </el-checkbox>
                                </div>
                                <div style="padding-left: 20px;padding-bottom: 20px;display: none">
                                    <el-checkbox v-model="formData.hasWHLocation"
                                                 :checked="formData.hasWHLocation==1?true:false"
                                                 :true-label="1" :false-label="0" border>设置: 库存启用库位
                                    </el-checkbox>
                                </div>
                                <div style="padding-left: 20px;padding-bottom: 20px;display: none">
                                    <el-checkbox v-model="formData.hasRate"
                                                 :checked="formData.hasRate==1?true:false"
                                                 :true-label="1" :false-label="0" border>设置: 入库类单据启用税率
                                    </el-checkbox>
                                </div>
                                <div style="padding-left: 20px;padding-bottom: 20px">
                                    <el-checkbox v-model="formData.mustReview"
                                                 :checked="formData.mustReview==1?true:false"
                                                 :true-label="1" :false-label="0" border>设置: 账单需要审核
                                    </el-checkbox>
                                </div>
                                <div style="padding-left: 20px;padding-bottom: 20px">
                                    <el-checkbox v-model="formData.minSalePrice"
                                                 :checked="formData.minSalePrice==1?true:false"
                                                 :true-label="1" :false-label="0" border>设置: 销售启用最低销售价限制
                                    </el-checkbox>
                                </div>
                            </div>
                            <div style="text-align: center;padding: 10px 0px 20px 0px">
                                <el-button type="primary" @click="submitForm">保存设置</el-button>
                            </div>

                        </el-tab-pane>
                        <el-tab-pane name="second">
                            <span slot="label">
                                <i class="el-icon-paperclip"></i>  精确度
                            </span>
                            <div style="text-align: left">
                                <div style="padding-left: 20px;padding-bottom: 20px">
                                    <el-form label-width="120px">
                                        <el-form-item label="数量">
                                            <el-input-number v-model="formData.precisionNum"  :min="0" :max="10"></el-input-number>
                                        </el-form-item>
                                        <el-form-item label="单价">
                                            <el-input-number v-model="formData.precisionPrice"  :min="0" :max="10"></el-input-number>
                                        </el-form-item>
                                        <el-form-item label="小计">
                                            <el-input-number v-model="formData.precisionTotal"  :min="0" :max="10"></el-input-number>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                            <div style="text-align: center;padding: 10px 0px 20px 0px">
                                <el-button type="primary" @click="submitForm">保存设置</el-button>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="third">
                            <span slot="label">
                                <i class="el-icon-date"></i>  财务结账日
                            </span>
                            <div style="text-align: left">
                                <div style="padding-left: 20px;padding-bottom: 20px">
                                    <el-form label-width="120px">
                                        <el-form-item label="整月结账">
                                            <el-radio v-model="formData.accountKind" :label="1" border> 整月结账 </el-radio>
                                            <span>每月月底结账</span>
                                        </el-form-item>
                                        <el-form-item label="固定结账">
                                            <el-radio v-model="formData.accountKind" :label="0" border> 固定结账 </el-radio>
                                            指定每月<el-input-number v-model="formData.accountDate" :min="1" :max="31"></el-input-number>日为财务结账日
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                            <div style="text-align: center;padding: 10px 0px 20px 0px">
                                <el-button type="primary" @click="submitForm">保存设置</el-button>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    export default {
        name: 'optionSet',
        props: ['menuData'],
        components: {},
        data() {
            return {
                activeName: "first",
                formData: {},
                loading: false,
            }
        },
        async mounted() {
            await this.getData()
        },
        methods: {
            async getData() {
                this.loading = true;
                let param = {
                    url: "/systemoptions/list",
                    param: {}
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.formData = data.data;
                }
                this.loading = false;
            },

            async submitForm() {
                this.loading = true;
                let param = {
                    ...this.formData,
                }
                const data = await this.$sqlOpt.save.save(param, "/systemoptions/save");
                this.loading = false;

                if (data.infoCode === '0') {
                    this.$message.success("保存成功")
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;

            ::v-deep .el-form-item__label {
                background-color: #c8ddf3;
                line-height: 38px;
                text-align: center;
                border: 1px solid rgba(0, 0, 0, 0.1);;
            }
        }

        .dialog_body{
            /*border-left: 10px solid rgba(28, 136, 201, 0.6);*/
            /*border-right: 10px solid rgba(28, 136, 201, 0.6);*/
            /*border-bottom: 10px solid rgba(28, 136, 201, 0.6);*/
            /*background-color: rgba(193, 245, 236, 0.15);*/
        }
    }
</style>